exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pad[data-v-ba27527e]{\n  padding:1em;\n}\n", ""]);

// exports
